import { createAction } from "typesafe-actions";
export const gotoFirst = createAction("KPTABLE_GOTO_FIRST", (id) => ({ id }))();
export const gotoNext = createAction("KPTABLE_GOTO_NEXT", (id) => ({ id }))();
export const gotoPrev = createAction("KPTABLE_GOTO_PREV", (id) => ({ id }))();
export const cursedRegister = createAction("KPTABLE_REGISTER", (id, state) => ({ id, state }))();
export const setCursors = createAction("KPTABLE_SET_CURSORS", (id, next, prev) => ({ id, next, prev }))();
